export default __webpack_public_path__ + "static/media/G5584.81de5763.png";